import React from 'react';

const IconSurvey = () => {
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 600 600">
      <g>
        <rect x="81.7" y="36.3" className="sm-home__survey-icon-styling" width="437.7" height="525.2" />
        <line className="sm-home__survey-icon-styling" x1="252.4" y1="174.3" x2="418.8" y2="174.3" />
        <line className="sm-home__survey-icon-styling" x1="252.4" y1="299.5" x2="418.8" y2="299.5" />
        <circle id="XMLID_24_" className="sm-home__icon-fill" cx="192.2" cy="298.9" r="18.1" />
        <line className="sm-home__survey-icon-styling" x1="252.4" y1="424.6" x2="418.8" y2="424.6" />
        <circle id="XMLID_23_" className="sm-home__icon-fill" cx="192.2" cy="424.1" r="18.1" />
        <polyline className="sm-home__survey-icon-styling" points="235.8,133 177,191.9 148.5,163.5" />
      </g>
    </svg>
  );
};

export default IconSurvey;
